import Vue from 'vue';
import { beforeRouteEnter } from '@assets/js/routerPageHook.js';
import BannerBtnPractices from '@components/ui-components/banner-btn-practices/component.js';
import formGreen from '@components/base/form-green.vue';
import LoadMore from '@components/ui-components/load-more/load-more';
import doubleBlock from '@components/ui-components/double-block/component.js';
import onScrollAnimate from '@assets/js/scrollAnimate.js';
import {router} from "@src/routes";

export default {
    name: 'index',
    data() {
        return {
            template: '<main></main>',
            newPractices: [],
            pagination: null,
            disableLoadMore: false,
        }
    },
    components: {
        'banner-btn-practices-cmp': BannerBtnPractices,
        'form-green-cmp': formGreen,
        'load-more-cmp': LoadMore,
        'double-block-cmp': doubleBlock,
    },
    methods: {
        setPagination() {
            setTimeout(() => {
                this.pagination = this.$root.convertTwigToJs("pagination", ".js-pagination-practices");
            }, 100)
        },
    },
    mounted() {
        this.setPagination();
    },
    beforeRouteUpdate(to, from, next) {
        // если не loadMore
        if (!to.query.loadMore) {
            const path = to.path.replace(router.history.base, '');
            this.$root.setDataAnimateFalse();

            Vue.http.get(`templates${path}`, {params: to.query}).then(
                (data) => {
                    next();
                    setTimeout(() => {
                        this.template = data.data;
                        this.setPagination();
                        this.newPractices = [];
                    }, 500);
                },
                () => {
                    next('/404');
                }
            );
        } else {
            this.disableLoadMore = true;
            let url = (process.env.NODE_ENV !== 'production') ?
                'practices/index2.json' :
                to.path.substring(1).replace(router.history.base, '');

            Vue.http.get(url, { params: to.query }).then(
                (data) => {
                    next();
                    this.newPractices = this.newPractices.concat(data.data.items);
                    this.pagination = data.data.pagination;
                    this.disableLoadMore = false;
                    setTimeout(() => {
                        onScrollAnimate();
                    }, 10);
                },
                () => {
                    this.disableLoadMore = false;
                    next('/404');
                }
            );
        }
    },
    beforeRouteEnter,
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
};


// WEBPACK FOOTER //
// ./src/templates/pages/practices/index.js